import DOMPurify from 'dompurify';
import ConfigModel from '../Services/Config/ConfigModel';

function sanitize(innerHtml: string, withTargetAttr?: boolean): string {
  if (withTargetAttr) addTargetBlankAttrToATagSecurely();
  return DOMPurify.sanitize(innerHtml);
}

export function configuredSanitize(
  innerHtml: string,
  withTargetAttr: boolean,
  config: ConfigModel['sanitizeConfig']
): string {
  const dompurifyConfig: DOMPurify.Config & {
    RETURN_DOM_FRAGMENT?: false | undefined;
    RETURN_DOM?: false | undefined;
  } = {};

  if (config?.allowIframes) {
    dompurifyConfig.ADD_TAGS = ['iframe'];
  }

  if (withTargetAttr) addTargetBlankAttrToATagSecurely();

  return DOMPurify.sanitize(innerHtml, dompurifyConfig);
}

const addTargetBlankAttrToATagSecurely = () => {
  // For temporarily saving original target value
  const TEMP_TARGET_ATTRIBUTE = 'data-target-temp';
  const TEMP_ONCLICK_ATTRIBUTE = 'data-onclick-temp';

  /**
   * Add DOMPurify hook to handling exceptional rules for certain HTML attributes.
   */

  DOMPurify.addHook('beforeSanitizeAttributes', function (node) {
    // Preserve default target attribute value
    if (node.tagName === 'A') {
      const targetValue = node.getAttribute('target');
      if (targetValue) {
        node.setAttribute(TEMP_TARGET_ATTRIBUTE, targetValue);
      } else {
        // set default value
        node.setAttribute('target', '_self');
      }
      const onclickValue = node.getAttribute('onclick');
      if (onclickValue) {
        node.setAttribute(TEMP_ONCLICK_ATTRIBUTE, onclickValue);
      }
    }
  });

  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A') {
      if (node.hasAttribute(TEMP_TARGET_ATTRIBUTE)) {
        const value = node.getAttribute(TEMP_TARGET_ATTRIBUTE);
        if (value) node.setAttribute('target', value);
        node.removeAttribute(TEMP_TARGET_ATTRIBUTE);

        // Additionally set `rel="noopener"` to prevent another security issue.
        if (node.getAttribute('target') === '_blank') {
          node.setAttribute('rel', 'noopener');
        }
      }
      if (node.hasAttribute(TEMP_ONCLICK_ATTRIBUTE)) {
        const onclickValue = node.getAttribute(TEMP_ONCLICK_ATTRIBUTE);
        if (onclickValue) node.setAttribute('onclick', onclickValue);
        node.removeAttribute(TEMP_ONCLICK_ATTRIBUTE);
      }
    }
  });
};

export default sanitize;
